import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Panel, Field, Empty } from "@/components/Common";
import { FilesPanel } from "@/components/FilesPanel";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Documents() {
  const { user } = useAuth();
  const studio = user.role === "studio";
  const [sp, setSp] = useSearchParams();
  const [companies, setCompanies] = useState([]);
  const companyId = sp.get("company") || "";

  useEffect(() => {
    if (studio) api.get("/studio/overview").then((r) => setCompanies(r.data.companies));
  }, [studio]);

  return (
    <div>
      <PageHeader title="Documenti" subtitle={studio ? "Documenti condivisi con le aziende abbinate" : "Archivio documenti condiviso con il tuo studio"} />
      {studio && (
        <div className="mb-5 max-w-sm">
          <Field label="Azienda">
            <Select value={companyId || undefined} onValueChange={(v) => setSp({ company: v })}>
              <SelectTrigger data-testid="documents-company-select" className="bg-white"><SelectValue placeholder="Seleziona un'azienda…" /></SelectTrigger>
              <SelectContent>{companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.denominazione}</SelectItem>)}</SelectContent>
            </Select>
          </Field>
        </div>
      )}
      {studio && !companyId ? (
        <Empty text="Seleziona un'azienda per vedere i suoi documenti" />
      ) : (
        <Panel>
          <FilesPanel key={companyId} companyId={studio ? companyId : undefined} invoiceBase={studio ? undefined : "/app/fatture"} />
        </Panel>
      )}
    </div>
  );
}
